import { Injectable } from '@angular/core';

import { Observable, Observer } from 'rxjs';

import { WindowRef } from './window-ref';

@Injectable()
export class CustomerService {
  constructor(private windowRef: WindowRef) {

  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/customer-service.ts